/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Aria_SendInputs */

const tr_mascot_chat_aria_send = /** @type {(inputs: Mascot_Chat_Aria_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönder`)
};

const en_mascot_chat_aria_send = /** @type {(inputs: Mascot_Chat_Aria_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const de_mascot_chat_aria_send = /** @type {(inputs: Mascot_Chat_Aria_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden`)
};

const ru_mascot_chat_aria_send = /** @type {(inputs: Mascot_Chat_Aria_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Mascot_Chat_Aria_SendInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_aria_send = /** @type {((inputs?: Mascot_Chat_Aria_SendInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Aria_SendInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_aria_send(inputs)
	if (locale === "de") return de_mascot_chat_aria_send(inputs)
	if (locale === "ru") return ru_mascot_chat_aria_send(inputs)
	return tr_mascot_chat_aria_send(inputs)
});